export const firebaseAnalyticsEnabled = process.env.REACT_APP_FIREBASE_ANALYTICS_ENABLED;
export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSENGER_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

export const reactPixelEnabled = process.env.REACT_APP_FB_PIXEL_ENABLED;
export const reactPixelKey = process.env.REACT_APP_FB_PIXEL_KEY;

export const AppEnv = process.env.REACT_APP_ENV;
